// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-form-control::after {
  content: unset !important;
}

.filterBtn {
  margin: 0px 5px;
}

.mat-form-field {
  width: 100%;
}

::ng-deep .mat-table th.mat-header-cell {
  white-space: nowrap;
  padding: 8px 16px !important;
}

::ng-deep .mat-table td.mat-cell {
  padding: 8px 16px !important;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNhcmVwbHVzLW9yZGVycy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UseUJBQXlCO0FBQzNCOztBQUVBO0VBQ0UsZUFBZTtBQUNqQjs7QUFFQTtFQUNFLFdBQVc7QUFDYjs7QUFFQTtFQUNFLG1CQUFtQjtFQUNuQiw0QkFBNEI7QUFDOUI7O0FBRUE7RUFDRSw0QkFBNEI7QUFDOUIiLCJmaWxlIjoiY2FyZXBsdXMtb3JkZXJzLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZGF0ZS1mb3JtLWNvbnRyb2w6OmFmdGVyIHtcbiAgY29udGVudDogdW5zZXQgIWltcG9ydGFudDtcbn1cblxuLmZpbHRlckJ0biB7XG4gIG1hcmdpbjogMHB4IDVweDtcbn1cblxuLm1hdC1mb3JtLWZpZWxkIHtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbjo6bmctZGVlcCAubWF0LXRhYmxlIHRoLm1hdC1oZWFkZXItY2VsbCB7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIHBhZGRpbmc6IDhweCAxNnB4ICFpbXBvcnRhbnQ7XG59XG5cbjo6bmctZGVlcCAubWF0LXRhYmxlIHRkLm1hdC1jZWxsIHtcbiAgcGFkZGluZzogOHB4IDE2cHggIWltcG9ydGFudDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/careplus/careplus-orders/careplus-orders.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,w0BAAw0B","sourcesContent":[".date-form-control::after {\n  content: unset !important;\n}\n\n.filterBtn {\n  margin: 0px 5px;\n}\n\n.mat-form-field {\n  width: 100%;\n}\n\n::ng-deep .mat-table th.mat-header-cell {\n  white-space: nowrap;\n  padding: 8px 16px !important;\n}\n\n::ng-deep .mat-table td.mat-cell {\n  padding: 8px 16px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
